import Swal, { SweetAlertIcon } from 'sweetalert2'
import './alert.css'

const iconsType = {
    success: 'success',
    error: 'error',
}

const sweetAlert = (title: string, text: string, icon: SweetAlertIcon | undefined) =>
    Swal.fire({
        title,
        text,
        icon,
    })

export const sweetAlertError = (text: string) =>
    Swal.fire({
        title: 'Erreur',
        text,
        icon: 'error',
    })

export const sweetAlertSuccess = (text: string) =>
    Swal.fire({
        title: 'Succès',
        text,
        icon: 'success',
    })

export const sweetAlertConfirm = (text: string, title: string = 'Confirmation'): Promise<boolean> =>
    Swal.fire({
        title,
        text,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Confirmer',
        cancelButtonText: 'Annuler',
    }).then((result) => result.isConfirmed)

export default sweetAlert
